import "./TheQuiz.css";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Skeleton from "../../components/Skeleton";
import logo from "../../components/images/logo.png";

const TheQuiz = ({ dark, MyBaseUrl }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const CACHE_KEY = "latest_news";

  const fetchPosts = async (pageNumber = 1, append = false) => {
    try {
      if (pageNumber === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      const res = await fetch(
        `${MyBaseUrl}/posts?type=quiz`
      );

      const data = await res.json();

      const newPosts = data?.data?.data || [];
      const meta = data?.data?.meta;

      if (append) {
        setPosts((prev) => [...prev, ...newPosts]);
      } else {
        setPosts(newPosts);
      }

      setLastPage(meta?.last_page);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    const loadInitialPages = async () => {
      let currentPage = 1;

      for (let i = 0; i < 1; i++) {
        await fetchPosts(currentPage, i !== 0);
        currentPage++;
      }

      setPage(currentPage);
    };

    loadInitialPages();
  }, []);

  const loadMorePages = async () => {
    if (lastPage && page > lastPage) return;

    let currentPage = page;

    for (let i = 0; i < 1; i++) {
      if (lastPage && currentPage > lastPage) break;

      await fetchPosts(currentPage, true);
      currentPage++;
    }

    setPage(currentPage);
  };

  return (

    <>
<Helmet>
  <title>Latest Football News | Goal Arena</title>

  <meta
    name="description"
    content="Get the latest football news, match updates, transfer news, and highlights from all major football competitions around the world."
  />

  <meta
    name="keywords"
    content="football news, latest football updates, match news, transfer news, soccer news, goal arena"
  />

  <meta property="og:title" content="Latest Football News | Goal Arena" />
  <meta
    property="og:description"
    content="Stay updated with breaking football news, match reports, and global football updates."
  />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Latest Football News | Goal Arena" />
  <meta
    name="twitter:description"
    content="Read the latest football news, highlights, and updates from around the world."
  />
  <meta name="twitter:image" content="/news-banner.jpg" />
</Helmet>

    <div className="homer">
      <div
        className="theQuizWrapper"
      >

        {loading ? (
          
                <Skeleton dark={dark} count={6} />
        ) : posts.length <= 0 ? (
          <p style={{ textAlign: "center", marginTop: "40px" }}>
            No news available
          </p>
        ) : (
          <>
            <section className="firstsection">
                
                <h1 style={dark ? { color: "#fafafa" } : {}}>
                Latest Football Quizzes
                </h1>
              {posts.slice(0, 1).map((item, index) => {
                return (
                  <NavLink
                    to={`/news/${item.slug}`}
                    key={item.id || index}
                    className="newsCard"
                    style={dark ? { backgroundColor: "#333333ff" } : {}}
                  >
                    <div className="imgWrap">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="content deep">
                      <h3 style={dark ? { color: "#fff" } : {}}>
                        {item.title}
                      </h3>

                      <div className="meta">
                        <span>
                          {item?.author?.name}
                        </span>

                        <span>
                          {item?.published_at &&
                            new Date(item?.published_at).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              }
                            )}
                        </span>
                      </div>
                    </div>
                  </NavLink>
                );
              })}
            </section>

            <div className="latestGrid">
              {posts.slice(1).map((item, index) => {
                return (
                  <NavLink
                    to={`/news/${item.slug}`}
                    key={item.id || index}
                    className="newsCard"
                    style={dark ? { backgroundColor: "#333333ff" } : {}}
                  >
                    <div className="imgWrap">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="content">
                      <h3 style={dark ? { color: "#fff" } : {}}>
                        {item.title}
                      </h3>

                      <div className="meta">
                        <span>
                          {item?.author?.name}
                        </span>

                        <span>
                          {item?.published_at &&
                            new Date(item?.published_at).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              }
                            )}
                        </span>
                      </div>
                    </div>
                  </NavLink>
                );
              })}
            </div>

            {lastPage && page <= lastPage && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  onClick={loadMorePages}
                  disabled={loadingMore}
                  className={`view-all-btn ${dark ? "dark" : ""}`}
                >
                  {loadingMore ? "Loading..." : "See More"}
                </button>
              </div>
            )}
          </>
        )}
      </div>

      
    </div>
    </>
  );
};

export default TheQuiz;